<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="py-8 px-10 mx-auto max-w-screen-xl lg:py-16">
      <h2 class="mb-4 text-xl font-bold text-gray-900 dark:text-white text-center">Finanzas y Rastreos</h2>

      <!-- Inventario -->
      <div class="flex flex-col w-full mt-8">
        <h2 class="text-lg font-semiboldbold text-gray-900 dark:text-white mb-4">Inventario Disponible</h2>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">Medicamento</th>
                <th scope="col" class="px-6 py-3">Cantidad</th>
                <th scope="col" class="px-6 py-3">Precio Venta por Dosis</th>
                <th scope="col" class="px-6 py-3">Total Despachado</th>
                <th scope="col" class="px-6 py-3">Inversión en Compra</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingInventario" class="text-center">
                <td colspan="5">
                  <div class="flex justify-center items-center py-4">
                    <div class="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                </td>
              </tr>
              <tr v-for="medicamento in inventarioFiltrado" :key="medicamento.id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {{ medicamento.nombre }}
                </th>
                <td class="px-6 py-4">{{ medicamento.cantidad || 0 }} frascos</td>
                <td class="px-6 py-4">${{ medicamento.precioVentaPorDosis }}</td>
                <td class="px-6 py-4">{{ medicamento.despachado || 0 }} dosis</td>
                <td class="px-6 py-4">${{ medicamento.costoPorFrasco }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Total Recolectado -->
      <div
        class="mt-8 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg flex flex-col gap-3 justify-center  md:flex-row w-full items-center">
        <div class="flex flex-col w-full items-center">
          <h2 class="text-lg text-center font-semibold text-gray-900 dark:text-white mb-2">Total de Dinero Recolectado
          </h2>
          <p class="text-gray-900 dark:text-white">${{ totalDineroRecolectado }}</p>
        </div>
        <!-- Filtro de mes -->
        <div class="flex flex-col w-full items-center mb-4">
          <label class="block text-sm font-medium text-gray-900 dark:text-white mr-2">Filtrar por mes:</label>
          <select v-model="mesSeleccionado" @change="filtrarFinanzas"
            class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-max p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white">
            <option disabled value="">Seleccione un mes</option>
            <option v-for="(mes, index) in meses" :key="index" :value="mes">{{ mes }}</option>
          </select>
          <!-- Mostrar mensaje con los ingresos filtrados -->
          <p v-if="mesSeleccionado">{{ mesSeleccionado }}: $ {{ dineroFiltrado.toFixed(2) }}</p>
        </div>

      </div>




      <!-- Enfermeros Activos -->
      <div class="flex flex-col w-full mt-8">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Enfermeros Activos y Despachos</h2>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">Enfermero</th>
                <th scope="col" class="px-6 py-3">Total Medicamentos Despachados</th>
                <th scope="col" class="px-6 py-3">Total Dinero Recolectado</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingEnfermeros" class="text-center">
                <td colspan="3">
                  <div class="flex justify-center items-center py-4">
                    <div class="w-8 h-8 border-4 border-green-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                </td>
              </tr>
              <tr v-for="enfermero in enfermerosActivos" :key="enfermero.id"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {{ enfermero.nombre }}
                </th>
                <td class="px-6 py-4">{{ enfermero.totalDespachado }} dosis</td>
                <td class="px-6 py-4">${{ formatearPrecio(enfermero.totalRecolectado) }}</td>

              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Comparativa -->
      <div class="flex flex-col mt-8 w-full">
        <h2 class="text-lg font-semibold text-gray-900 dark:text-white mb-4">Comparativa de Ingresos</h2>
        <div class="relative overflow-x-auto shadow-md sm:rounded-lg">
          <table class="w-full text-sm text-left text-gray-500 dark:text-gray-400">
            <thead class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
              <tr>
                <th scope="col" class="px-6 py-3">Periodo</th>
                <th scope="col" class="px-6 py-3">Ingresos</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="loadingComparativas" class="text-center">
                <td colspan="2">
                  <div class="flex justify-center items-center py-4">
                    <div class="w-8 h-8 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
                  </div>
                </td>
              </tr>
              <tr v-for="comparativa in comparativas" :key="comparativa.periodo"
                class="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                <th scope="row" class="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                  {{ comparativa.periodo }}
                </th>
                <td class="px-6 py-4">${{ comparativa.ingresos }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { collection, getDocs } from "firebase/firestore";
import { db } from '../../firebase';

export default {
  data() {
    return {
      inventario: [],
      filtroSeleccionado: 'mes',
      comparativas: [],
      enfermerosActivos: [],
      enfermerosActivosCompletos: [], // Nueva propiedad para guardar todos los enfermeros sin filtrar
      inventarioFiltrado: [],
      loadingInventario: true,
      loadingEnfermeros: true,
      loadingComparativas: true,
      meses: [
        'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
        'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
      ],
      mesSeleccionado: '',
      citasGlobales: [], // Nueva propiedad para almacenar todas las citas
      enfermerosNombres: {}, // Nueva propiedad para almacenar los nombres de los enfermeros
      totalDineroRecolectado: 0,
      loading: false,
    };
  },
  methods: {
    // Método adicional para cargar los nombres de los enfermeros
    async cargarNombresEnfermeros() {
      const enfermerosSnapshot = await getDocs(collection(db, "enfermeros"));
      const enfermerosMap = {};
      enfermerosSnapshot.forEach(docSnap => {
        const data = docSnap.data();
        enfermerosMap[docSnap.id] = data.nombre; // Suponiendo que tienes un campo 'nombre'
      });
      return enfermerosMap;
    },
    async cargarFinanzas() {
      this.loading = true;

      const [medicSnapshot, citasSnapshot, enfermerosSnapshot] = await Promise.all([
        getDocs(collection(db, "medicamentos")),
        getDocs(collection(db, "citasGlobales")),
        getDocs(collection(db, "enfermeros"))
      ]);

      this.inventario = medicSnapshot.docs.map(docSnap => ({
        id: docSnap.id,
        nombre: docSnap.data().nombre || "Desconocido",
        cantidad: docSnap.data().cantidad || 0,
        precioVentaPorDosis: docSnap.data().precioVentaPorDosis || 0,
        despachado: 0, // Reinicia los despachos para calcular correctamente
        costoPorFrasco: docSnap.data().costoPorFrasco || 0,
        fechaCompra: docSnap.data().fechaCompra || new Date().toISOString(),
      }));

      // Guardar los nombres de los enfermeros
      this.enfermerosNombres = {};
      enfermerosSnapshot.docs.forEach(docSnap => {
        const data = docSnap.data();
        this.enfermerosNombres[docSnap.id] = data.nombre || "Nombre Desconocido";
      });

      // Guardar todas las citas para poder filtrarlas después
      this.citasGlobales = citasSnapshot.docs.map(docSnap => {
        const data = docSnap.data();
        return {
          id: docSnap.id,
          ...data,
          fecha: data.fecha ? new Date(data.fecha) : new Date()
        };
      });

      this.totalDineroRecolectado = 0;
      const enfermerosTotales = {};
      const citasProcesadas = new Set();

      await Promise.all(citasSnapshot.docs.map(async (docSnap) => {
        const data = docSnap.data();

        if (citasProcesadas.has(docSnap.id)) return; // Evitar procesar citas duplicadas
        citasProcesadas.add(docSnap.id);

        const costoTotal = data.medicamentos ? data.medicamentos.reduce((total, med) => {
          const medicamento = this.inventario.find(item => item.nombre === med.nombre);
          if (medicamento) {
            // Usar precio personalizado si existe
            const precio = med.precioPersonalizado !== undefined ? 
                          med.precioPersonalizado : 
                          medicamento.precioVentaPorDosis;
            return total + (med.dosis * precio);
          }
          return total;
        }, 0) : 0;

        this.totalDineroRecolectado += costoTotal;

        const nombreEnfermero = this.enfermerosNombres[data.enfermero] || "Nombre Desconocido";
        const enfermero = enfermerosTotales[nombreEnfermero] || { totalRecolectado: 0, totalDespachado: 0 };
        enfermero.totalRecolectado += costoTotal;

        if (data.medicamentos){
          data.medicamentos.forEach((med) => {
            const medicamento = this.inventario.find(item => item.nombre === med.nombre);
            if (medicamento) {
              medicamento.despachado += med.dosis || 0;
              enfermero.totalDespachado += med.dosis || 0;
            }
          });
        }

        enfermerosTotales[nombreEnfermero] = enfermero;
      }));

      // Guardar la lista completa de enfermeros
      this.enfermerosActivosCompletos = Object.keys(enfermerosTotales).map(nombre => ({
        nombre,
        totalRecolectado: enfermerosTotales[nombre].totalRecolectado,
        totalDespachado: enfermerosTotales[nombre].totalDespachado,
      }));

      // Inicialmente, mostrar todos los enfermeros
      this.enfermerosActivos = [...this.enfermerosActivosCompletos];

      this.totalDineroRecolectado = this.formatearPrecio(this.totalDineroRecolectado);

      this.filtrarFinanzas();
      this.generarComparativa();
      this.loading = false;
    },

    filtrarFinanzas() {
  if (!this.mesSeleccionado) {
    // Si no hay mes seleccionado, mostrar todo
    this.inventarioFiltrado = this.inventario;
    this.enfermerosActivos = [...this.enfermerosActivosCompletos];
  } else {
    const mesIndex = this.meses.indexOf(this.mesSeleccionado);
    
    // Filtrar citas por mes
    const citasFiltradas = this.citasGlobales.filter(cita => {
      return cita.fecha && cita.fecha.getMonth() === mesIndex;
    });
    
    // Crear un conjunto de medicamentos despachados en el mes seleccionado
    const medicamentosDespachadosPorMes = new Set();
    let medicamentosConCantidades = {};
    
    // Recorrer las citas filtradas para identificar medicamentos despachados
    citasFiltradas.forEach(cita => {
      if (!cita.medicamentos) return;
      
      cita.medicamentos.forEach(med => {
        medicamentosDespachadosPorMes.add(med.nombre);
        
        // Acumular las dosis despachadas por medicamento
        if (!medicamentosConCantidades[med.nombre]) {
          medicamentosConCantidades[med.nombre] = {
            despachado: 0
          };
        }
        medicamentosConCantidades[med.nombre].despachado += med.dosis || 0;
      });
    });
    
    // Filtrar el inventario para mostrar solo los medicamentos despachados en el mes seleccionado
    this.inventarioFiltrado = this.inventario
      .filter(med => medicamentosDespachadosPorMes.has(med.nombre))
      .map(med => {
        // Crear una copia del medicamento para no modificar el original
        const medCopia = { ...med };
        // Actualizar la cantidad despachada según las citas del mes
        if (medicamentosConCantidades[med.nombre]) {
          medCopia.despachado = medicamentosConCantidades[med.nombre].despachado;
        }
        return medCopia;
      });
    
    // Recalcular totales para cada enfermero basado en las citas filtradas
    const enfermerosTotalesFiltrados = {};
    
    citasFiltradas.forEach(cita => {
      if (!cita.enfermero || !cita.medicamentos) return;
      
      const nombreEnfermero = this.enfermerosNombres[cita.enfermero] || "Nombre Desconocido";
      const enfermero = enfermerosTotalesFiltrados[nombreEnfermero] || { totalRecolectado: 0, totalDespachado: 0 };
      
      // Calcular costo total de esta cita
      const costoTotal = cita.medicamentos.reduce((total, med) => {
        const medicamento = this.inventario.find(item => item.nombre === med.nombre);
        if (medicamento) {
          // Usar precio personalizado si existe
          const precio = med.precioPersonalizado !== undefined ? 
                        med.precioPersonalizado : 
                        medicamento.precioVentaPorDosis;
          return total + (med.dosis * precio);
        }
        return total;
      }, 0);
      
      enfermero.totalRecolectado += costoTotal;
      
      // Sumar dosis despachadas
      cita.medicamentos.forEach(med => {
        enfermero.totalDespachado += med.dosis || 0;
      });
      
      enfermerosTotalesFiltrados[nombreEnfermero] = enfermero;
    });
    
    // Actualizar la lista de enfermeros activos con los datos filtrados
    this.enfermerosActivos = Object.keys(enfermerosTotalesFiltrados).map(nombre => ({
      nombre,
      totalRecolectado: enfermerosTotalesFiltrados[nombre].totalRecolectado,
      totalDespachado: enfermerosTotalesFiltrados[nombre].totalDespachado,
    }));
  }
},
    
    generarComparativa() {
      const hoy = new Date();
      const mesActual = hoy.getMonth();
      const anoActual = hoy.getFullYear();

      // Calcular el inicio de la semana (7 días atrás desde hoy)
      const inicioSemana = new Date(hoy);
      inicioSemana.setDate(hoy.getDate() - 6);
      inicioSemana.setHours(0, 0, 0, 0);

      let ingresosMesActual = 0;
      let ingresosSemanaActual = 0;
      let ingresosAnoActual = 0;
      let ingresosMesAnterior = 0;

      // Recorremos las citas para calcular los ingresos por periodo
      this.inventario.forEach((med) => {
        const fechaCompra = new Date(med.fechaCompra);

        if (!isNaN(fechaCompra)) {
          const ingresos = med.despachado * med.precioVentaPorDosis;

          // Verificar si la fecha de compra es dentro del año actual
          if (fechaCompra.getFullYear() === anoActual) {
            ingresosAnoActual += ingresos;

            // Verificar si la fecha de compra es en el mes actual
            if (fechaCompra.getMonth() === mesActual) {
              ingresosMesActual += ingresos;
            }

            // Verificar si la fecha de compra es en la semana actual
            if (fechaCompra >= inicioSemana && fechaCompra <= hoy) {
              ingresosSemanaActual += ingresos;
            }
          }

          // Verificar si la fecha de compra es en el mes anterior
          if (fechaCompra.getFullYear() === anoActual && fechaCompra.getMonth() === mesActual - 1) {
            ingresosMesAnterior += ingresos;
          }
        }
      });

      this.comparativas = [
        { periodo: "Mes Actual", ingresos: this.formatearPrecio(ingresosMesActual) },
        { periodo: "Semana Actual", ingresos: this.formatearPrecio(ingresosSemanaActual) },
        { periodo: "Mes Anterior", ingresos: this.formatearPrecio(ingresosMesAnterior) },
        { periodo: "Año Actual", ingresos: this.formatearPrecio(ingresosAnoActual) },
      ];
    },

    formatearPrecio(valor) {
      return parseFloat(valor).toFixed(2);
    }
  },
  watch: {
    mesSeleccionado() {
      this.filtrarFinanzas();
    }
  },
  computed: {
    totalDineroRecolectadoFiltrado() {
    if (!this.mesSeleccionado) return 0;
    const mesIndex = this.meses.indexOf(this.mesSeleccionado);
    
    // Filtrar citas por mes
    const citasFiltradas = this.citasGlobales.filter(cita => {
      return cita.fecha && cita.fecha.getMonth() === mesIndex;
    });
    
    // Calcular total de dinero recolectado en esas citas
    return citasFiltradas.reduce((total, cita) => {
      if (!cita.medicamentos) return total;
      
      const costoTotal = cita.medicamentos.reduce((subtotal, med) => {
        const medicamento = this.inventario.find(item => item.nombre === med.nombre);
        if (medicamento) {
          // Usar precio personalizado si existe
          const precio = med.precioPersonalizado !== undefined ? 
                        med.precioPersonalizado : 
                        medicamento.precioVentaPorDosis;
          return subtotal + (med.dosis * precio);
        }
        return subtotal;
      }, 0);
      
      return total + costoTotal;
    }, 0);
  },
  dineroFiltrado() {
    return this.totalDineroRecolectadoFiltrado;
  }
},
  mounted() {
    this.filtrarFinanzas();
    this.cargarFinanzas();
    // Simulación de carga de datos
    setTimeout(() => {
      this.loadingInventario = false;
      this.loadingEnfermeros = false;
      this.loadingComparativas = false;
    }, 3000);
  },
};
</script>

<style scoped>
/* No se necesitan estilos adicionales ya que usamos Tailwind */
</style>
